import { Trans } from '@lingui/react/macro';
import { Badge } from '@repo/videa-components/src/ui/badge';
import classNames from 'classnames';

import { useGetDateFNSLocale } from '../../../../locales/helpers';
import { parseAndFormatDate } from '../../../../utils/parseDate';

export const CompletedTreatmentBadge = ({
  completed,
  completedDate,
}: {
  completed: boolean;
  completedDate: string;
}) => {
  const dateFNSLocale = useGetDateFNSLocale();
  if (completedDate) {
    return (
      <Badge
        className={classNames(
          '!vai-bg-aqua-400 hover:!vai-bg-aqua-400 vai-rounded-xl vai-py-1 vai-px-2 vai-font-inter',
        )}
      >
        <p>{parseAndFormatDate(completedDate, undefined, dateFNSLocale)}</p>
      </Badge>
    );
  }
  if (completed) {
    return (
      <Badge
        className={classNames(
          '!vai-bg-aqua-400 hover:!vai-bg-aqua-400 vai-rounded-xl vai-py-1 vai-px-2 vai-font-inter',
        )}
      >
        <p>
          <Trans>Completed</Trans>
        </p>
      </Badge>
    );
  }

  return null;
};
